import PropTypes from 'prop-types';
import cn from 'classnames';
import {statusIcons} from '../../../../assets/svg';

import './cocTestResultIndicator.scss';
import {getEnumValue, getEnumLabel, enumTypes} from '../../../utils/enumHelper';

const getResultConfig = (result) => {
  const config = {
    [getEnumValue(enumTypes.COC_TEST_RESULT)('PASS')]: {Icon: statusIcons.statusPass, className: 'pass'},
    [getEnumValue(enumTypes.COC_TEST_RESULT)('FAIL')]: {Icon: statusIcons.statusFail, className: 'fail'},
    [getEnumValue(enumTypes.COC_TEST_RESULT)('PENDING_CUSTOMER_ACCEPTANCE')]: {Icon: statusIcons.statusPending, className: 'pending'},
    [getEnumValue(enumTypes.COC_TEST_RESULT)('ACCEPTED_BY_CUSTOMER')]: {Icon: statusIcons.statusPass, className: 'pass'},
  };
  return config[result] || {};
}

export default function CocTestResultIndicator ({ result = null }) {

  if (!result) {
    return null;
  }

  const {Icon, className} = getResultConfig(result);
  const label = getEnumLabel(enumTypes.COC_TEST_RESULT)(result);

  return (
    <div className={cn('coc-test-result-indicator', className)}>
      {Icon && <Icon className='coc-result-indicator__icon'/>}
      {label && <span>{label}</span>}
    </div>
  )
}

CocTestResultIndicator.propTypes = {
  result: PropTypes.string,
}
